export const SET_WORKERS = 'SET_WORKERS';